export const config = {
    cssVarPrefix: 'fp',

    initialColorMode: 'dark',
    useSystemColorMode: false,
};